export default __webpack_public_path__ + "static/media/covid.4097dc4b.svg";